import React, { useEffect, useState, useRef } from "react";
import HoldButton from "../helpers/holdButton";
import Debugger from "../helpers/debugger";
import DebuggerGUI from "../helpers/GUI/DebuggerGUIProps";

import gsap from "gsap";
import HandDetection from "../helpers/detection2"; // this loads the new model
import DebuggerCamera from "../helpers/GUI/DebuggerCamera";
import { Options } from "../../types";

import {
  GlobalMode,
  GlobalModeValues,
  getDefaultMode,
  saveMode,
} from "../helpers/mode";
import powerUpVerification from "../helpers/powerUpVerification";
import {getParsedHashtableProfiles, setHasTableProfilesStorage} from "../helpers/disabledProfile";
import { getCurrentVideo, getRunExperience } from "../helpers/screensaverVideo";
import { useNavigate } from "react-router";

import { useUsermaven } from "@usermaven/react";
import { usePageView } from "@usermaven/react";

interface ScreenSaverProps {
  triggerTransition: (to: string) => void;
}

const ScreenSaver: React.FC <ScreenSaverProps> = ({ triggerTransition }) => {
  usePageView();
  const { track } = useUsermaven();
  let navigate = useNavigate();

  const [showDebugger, setShowDebugger] = useState<boolean>(false);

  // Create global variable for modes "GESTURE" or "TOUCH"
  const [usingMode, setUsingMode] = useState<GlobalMode>(getDefaultMode());

  const [currentVideo, setCurrentVideo] = useState(getCurrentVideo() || "screensaver1.mp4");
  const [hashTableProfiles, setHashTableProfiles] = useState(getParsedHashtableProfiles());

  const savedOptions = localStorage.getItem("camera_options") as string;
  const parsedOptions = savedOptions ? JSON.parse(savedOptions) : null;
  let [options, setOptions] = useState<Options>(
    parsedOptions
      ? parsedOptions
      : {
          maxNumHands: 1, // n
          modelComplexity: 1, // 0 - 1
          minDetectionConfidence: 0.5, // 0.0 - 1.0
          minTrackingConfidence: 0.8, // 0.0 - 1.0
        }
  );

  const [runTouchExperience, setRunTouchExperience] = useState(getRunExperience() || "true");

  const [signDetected, setSignDetected] = useState(false);
  const detectionRef = useRef<boolean | null>(null);
  const holdTimer = useRef<NodeJS.Timeout | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [signHeld, setSignHeld] = useState(false);
  const [isHolding, setIsHolding] = useState(false);
  const isHoldingRef = useRef(isHolding);
  const [intervalRef, setIntervalRef] = useState<NodeJS.Timeout | null>(null);
  const intervalRewind = useRef<NodeJS.Timeout | null>(null);

  const [secondsHolder, setSecondsHolder] = useState<number | null>(null);

  const changeMode = (mode: GlobalMode) => {
    setUsingMode(mode);
    saveMode(mode); // Guardamos el nuevo modo
  };

  useEffect(() => {
    if (signDetected) {
      holdTimer.current = setTimeout(() => {
        setSignHeld(true);
      }, 500);
    } else {
      if (holdTimer.current) {
        clearTimeout(holdTimer.current);
        holdTimer.current = null;
      }
    }

    return () => {
      if (holdTimer.current) clearTimeout(holdTimer.current);
    };
  }, [signDetected]);

  useEffect(() => {
    detectionRef.current = signDetected;
  }, [signDetected]);

  useEffect(() => {
    isHoldingRef.current = isHolding;
  }, [isHolding]);

  useEffect(() => {
    if (videoRef.current && signHeld) {
      powerUpVerification(
        videoRef as React.RefObject<HTMLVideoElement>,
        signHeld,
        setSignHeld,
        detectionRef,
        intervalRef,
        setIntervalRef,
        intervalRewind,
        usingMode,
        isHoldingRef
      );
    }
  }, [detectionRef, signHeld, isHoldingRef]); // eslint-disable-line

  const changeCameraParameters = (parameter: string, value: string) => {
    const parsedValue = parseFloat(value);

    setOptions((prevOptions) => ({
      ...prevOptions,
      [parameter]: isNaN(parsedValue) ? value : parsedValue,
    }));
  };

  interface ButtonsChangeValueParams {
    sum: boolean;
    value: number | string | undefined;
    parameter: string;
    step: number;
    min: number;
    max: number;
  }

  const buttonsChangeValue = ({
    sum,
    value,
    parameter,
    step,
    min,
    max,
  }: ButtonsChangeValueParams) => {
    console.log("value, current", { sum, value, parameter, step, min, max });

    if (value === undefined) return;

    let newValue = sum ? Number(value) + step : Number(value) - step;

    if (newValue < min) newValue = min;
    if (newValue > max) newValue = max;

    console.log("newValue", newValue);

    changeCameraParameters(parameter, newValue.toString());
  };

  useEffect(() => {
    localStorage.setItem("camera_options", JSON.stringify(options));
  }, [options]);

  const handleTouchExperience = () => {
    track('Start Experience', {
    });
  }
  

  return (
    <div id="screensaver" className="h-screen">
      <Debugger setShowDebugger={setShowDebugger} showDebugger={showDebugger} />

      <DebuggerGUI showDebugger={showDebugger} setShowDebugger={setShowDebugger} setHashTableProfiles={setHashTableProfiles} hashTableProfiles={hashTableProfiles} />

      <div
       className="h-screen bg-white"
       onClick={() => { runTouchExperience === "true" && setSignHeld(true); setIsHolding(true); handleTouchExperience()}}>

        <video
          autoPlay
          playsInline
          loop
          muted
          className={`h-full w-full object-cover pointer-events-none fixed `}
        >
          <source src={`./assets/screensavers/${currentVideo}`}  />
        </video>


        <video
          ref={videoRef}
          muted
          // controls
          className={`h-full w-full object-cover pointer-events-none opacity-0 fixed ${
            signHeld ? "block" : "hidden"
          }`}
          onEnded={() => navigate("/menu")}
          onLoadedMetadata={(e: any) => {
            setSecondsHolder(e.target.duration);
          }}
          onPlay={() => {
            gsap.fromTo(videoRef.current, {opacity: 0, },{opacity: 1} )
          }}
        >
          <source src="./assets/powerbyv.mp4" className="w-full h-full" />
        </video>
      </div>
    </div>
  );
};

export default ScreenSaver;
